import React, {Component, PropTypes} from 'react'

import ElmMain from '../../../elm/src/AdditionalInfosForm.elm'
import Elm from 'react-elm-components'
import {connect} from 'react-redux'
import config from '../../config'


class AdditionalInfos extends Component {
    render() {
        const {patrimonyUid} = this.props
        const apiUrl = config.api.url
        return <Elm src={ElmMain.Elm.AdditionalInfosForm} flags={{patrimonyUid, apiUrl}}/>
    }
}

export default connect(state => ({patrimonyUid: state.patrimony.patrimony.uid}))(AdditionalInfos)


// WEBPACK FOOTER //
// ./lib/patrimony/components/AdditionalInfos.js